import type { EmptyObject } from 'type-fest';

import { get, post } from '../../redux/api';
import { nuc } from '../../utils';
import type { SnapshotFilters } from '../../../shared/issuesV2/snapshots';
import type { AsyncTaskResponse } from '../../../shared/types/routes/common';
import type { GetIssueCountsResponse } from '../../../shared/types/routes/issueCounts';

function prepareFiltersForRequest(filters: SnapshotFilters) {
  return {
    ...filters,
    projectId: filters.projectId ? nuc(filters.projectId) : undefined,
  };
}

/** Fetches issue counts */
export const getIssueCounts = (filters: SnapshotFilters) =>
  get<GetIssueCountsResponse>('/api/issue_counts', false, prepareFiltersForRequest(filters));

/** Triggers an export */
export const triggerExport = (filters: SnapshotFilters) =>
  post<EmptyObject, AsyncTaskResponse>('/api/issue_counts/export', {}, { query: prepareFiltersForRequest(filters) });
